import React, { createContext, useContext, useState } from 'react';

export const SaleContext = createContext({});

export const SaleProvider = ({ children }) => {
  const [data, setData] = useState([]);
  return (
    <SaleContext.Provider value={{ data, setData }}>
      {children}
    </SaleContext.Provider>
  );
};

export const useSale = () => useContext(SaleContext);
